<template>
  <div>
    <Landing />
    <div class="">
      <h2 class="heading_fonts text-center pb-5">
        Ongoing Assessments
      </h2>
      <div class="ucontainer">
        <AllAssessment />
      </div>

      <JobSeeker />
      <Category />
      <HomeTrainersSaying />
      <Partner />
      <!-- <RecruiterForm /> -->
      <Trainer />
    </div>
  </div>
</template>
<script>
import AllAssessment from '../components/Homev2/AssessmentAll.vue'
import Landing from '../components/Homev2/Landing.vue'
// import HomeIm from '../components/home/home-im.vue'
import JobSeeker from '../components/Homev2/JobSeeker.vue'
import Category from '../components/Homev2/Category.vue'
import HomeTrainersSaying from '../components/Homev2/CompanyTestimonial.vue'
import Partner from '../components/Homev2/Recruit/PartnerCompanies.vue'
// import RecruiterForm from '../components/Homev2/RecruitersForm.vue'
import Trainer from '../components/Homev2/ForTrainer.vue'

export default {
  components: {
    Landing,
    AllAssessment,

    // HomeIm,
    JobSeeker,
    Category,
    HomeTrainersSaying,
    Partner,
    // RecruiterForm,
    Trainer,
  },

  created() {
    this.Loaded()
  },
}
</script>
<style scoped>
.heading_fonts {
  font: 800 2.1rem/2.3rem 'Manrope';
  letter-spacing: -2px;
  color: #29292b;
}
</style>
